/*eslint-disable*/
import React from "react";
import ReactMarkdown from "react-markdown";
import PulseCode from "../PulseCode/PulseCode";
import "./MarkdownRenderer.scss";

interface MarkdownRendererProps {
  content: string;
  className?: string;
}

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({
  content,
  className,
}) => {
  return (
    <div className={`markdown-content ${className || ""}`}>
      <ReactMarkdown
        className={className}
        components={{
          code({
            node,
            inline,
            className,
            children,
            ...props
          }: {
            node?: any;
            inline?: boolean;
            className?: string;
            children?: React.ReactNode;
          } & React.HTMLAttributes<HTMLElement>) {
            const match = /language-(\w+)/.exec(className || "");
            return !inline && match ? (
              <PulseCode>{String(children).replace(/\n$/, "")}</PulseCode>
            ) : (
              <code className={className} {...props}>
                {children}
              </code>
            );
          },
          // Add custom styling for other markdown elements
          h1: ({ node, ...props }) => (
            <h1 className="pl-heading-xl" {...props} />
          ),
          h2: ({ node, ...props }) => (
            <h2 className="pl-heading-l" {...props} />
          ),
          h3: ({ node, ...props }) => (
            <h3 className="pl-heading-m" {...props} />
          ),
          p: ({ node, ...props }) => <p className="pl-body-m" {...props} />,
          ul: ({ node, ...props }) => (
            <ul className="markdown-list" {...props} />
          ),
          ol: ({ node, ...props }) => (
            <ol className="markdown-list" {...props} />
          ),
          li: ({ node, ...props }) => (
            <li className="markdown-list-item" {...props} />
          ),
          a: ({ node, ...props }) => (
            <a {...props} target="_blank" rel="noopener noreferrer" />
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;
